import setting from '@/setting.js'
import store from '@/store'

export default {
  data () {
    return {
      backUrl: null,
      redirectUrl: null
    }
  },

  beforeRouteEnter (from, to, next) {
    // 戻り先URL (Cancel)
    // ※ `https://www.example.com/?backurl=*****`
    if (from.query.backurl) {
      // 永続化 (perpetuation)
      store.dispatch('setBackUrl', from.query.backurl)
    }

    // リダイレクトURL (Success)
    // ※ `https://www.example.com/?redirecturl=*****`
    if (from.query.redirecturl) {
      // 永続化 (perpetuation)
      store.dispatch('setRedirectUrl', from.query.redirecturl)
    }

    next(vm => {
      vm.backUrl = store.getters.backUrl || null
      vm.redirectUrl = store.getters.redirectUrl || null
    })
  },

  computed: {
    allowDomainUrl () {
      return (url) => {
        if (!url) {
          return setting.ecURL
        }

        // オープンリダイレクト対策
        // https://www.fastly.com/jp/blog/open-redirects-real-world-abuse-and-recommendations
        const info = url.match(/^https?:\/{2,}(.*?)(?:\/|\?|#|$)/)
        const domain = info ? info[1] : null
        if (!domain || !setting.allowRedirectDomains.includes(domain)) {
          // 許可しているドメイン以外は、受け付けない (クリア)
          url = null
        }

        return url || setting.ecURL
      }
    }
  },

  methods: {
    goBackToEcSite () {
      window.location.href = this.allowDomainUrl(this.backUrl)
    },

    goToEcSite () {
      window.location.href = this.allowDomainUrl(this.redirectUrl)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/redirect.mixin.js